

var _angular = require('angular');

var _uiRouter = require('uiRouter');

require('xo-page-components/src/aside-header/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

angular.module().directive('xoSepa', function () {
    return {
        template: _template2['default'],
        scope: {
            token: '=?',
            parentCallbacks: '=?',
            model: '=?',
            sidebar: '=?',
            hideparenthead: '=?'
        },
        controller: ['$scope', function ($scope) {

            if (!$scope.model) {
                return _uiRouter.$state.go('^.add');
            }

            $('body').addClass('pageSepaMandate');

            $scope.$on('$destroy', function () {
                $('body').removeClass('pageSepaMandate');
            });

            if ($scope.hideparenthead) {
                $scope.hideparenthead.toggle = true;
            }

            function getDate() {
                var today = new Date();
                var dd = today.getDate();
                var mm = today.getMonth() + 1; // January is 0!

                var yyyy = today.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                return dd + '.' + mm + '.' + yyyy;
            }

            $scope.date = getDate();
            $scope.onSubmit = function () {
                $scope.parentCallbacks.sepaDone();
            };
        }],

        link: function link($scope, element, attrs) {
            (0, _angular.$timeout)(function () {
                $(element).find('.asideContent').height($('#main').height() - $('#tray').find('.header').height() + 10);
            }, 10);
        }
    };
});

_angular.$timeout;

_uiRouter.$state;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/sepa/directive.js
// module chunks = 0